import * as Yup from 'yup';
import { DictLegalForm } from '@models';

export function useValidationSchema() {
  return Yup.object<DictLegalForm>().shape({
    name: Yup.string().nullable().required(),
  });
}
